<template>
  <section class="page-dashbord-all-courses mt-3">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header class="mb-3">
            <h2 class="font-18 text-right">مدیریت دوره ها</h2>
          </header>
          <b-card no-body class="mb-5">
            <b-tabs card>
                  <b-tab title="لیست دوره های غیر فعال" @click="getCourseUnPublish(1)">
                    <m-course-un-publish
                      :items="courseUnpublish"
                      v-if="courseUnpublish.length"
                      @getCourseUnPublish="getCourseUnPublish"
                    />
                  </b-tab>
                  <b-tab title="لیست دوره های فعال" @click="getCoursePublish(1)">
                    <m-course-publish
                      :items="coursePublish"
                      v-if="coursePublish.length"
                      @getCoursePublish="getCoursePublish"
                    />
                  </b-tab>
                </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MCoursePublish from "cp/dashboard-component/courses/course-publish";
import MCourseUnPublish from "cp/dashboard-component/courses/course-unpublish";
import MInstructorsActive from "cp/dashboard-component/courses/instructors-active";
import MInstructorsDActive from "cp/dashboard-component/courses/instructors-dactive";

export default {
  name: "page-dashbord-all-courses",
  components: {
    MCoursePublish,
    MCourseUnPublish,
    MInstructorsActive,
    MInstructorsDActive
  },
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    coursePublish() {
      return this.$store.state.dashboardAllCourses.coursePublish
    },
    courseUnpublish() {
      return this.$store.state.dashboardAllCourses.courseUnpublish
    }
  },
  destroyed() {
    this.$store.commit("dashboardAllCourses/clear");
  },
  mounted(){
    this.getCourseUnPublish(1)
  },
  methods: {
    async getCourseUnPublish(page) {
      this.isLoading = true;
      await this.$store.dispatch('dashboardAllCourses/getCourseUnPublish', { page_num: page, publish: false })
      this.isLoading = false;
    },
    async getCoursePublish(page) {
      this.isLoading = true;
      await this.$store.dispatch('dashboardAllCourses/getCoursePublish', { page_num: page, publish: true })
      this.isLoading = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/dashboard/allcourses.vue